<template>
    <div>
        <div style="display: flex">
            <a-form-item-rest v-if="props.isFiliale == 1">
                <a-input @change="
                    (res) => {
                        inputChange(res, 'filiale_full_name')
                    }
                " v-model:value="state.filiale_full_name" placeholder="总公司名称"></a-input>
            </a-form-item-rest>
            <a-form-item-rest v-if="props.isFiliale != 1">
                <a-input @change="
                    (res) => {
                        inputChange(res, 'name_division')
                    }
                " v-model:value="state.name_division" placeholder="名称区划"></a-input>
            </a-form-item-rest>
            <a-form-item-rest v-if="!state.no_word">
                <a-input @change="
                    (res) => {
                        inputChange(res, 'name_word_mark')
                    }
                " v-model:value="state.name_word_mark"
                    :placeholder="props.isFiliale == 1 ? '地域或字号:第一，湖南，长沙市' : '字号'"></a-input>
            </a-form-item-rest>
            <a-form-item-rest v-if="props.isFiliale != 1">
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" optionLabelProp="label"
                    popupClassName="principalName" :value="state.ondustry_representation_id" show-search
                    placeholder="行业表述" :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null" @search="handleSearch" @change="handleChange"
                    v-model:search-value="state.ondustry_keyword">
                    <a-select-option v-for="(item, index) in state.options" :key="index" :title="item.keyvalue"
                        :value="item.id" :label="item.keyname">
                        <div class="d-flex">
                            <span style="width: 160px">
                                {{ item.keyname }}
                            </span>
                            <!-- <span class="flex-1">
                <span class="top"> 置顶 </span>
              </span> -->
                            <span
                                style="width: 230px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px">
                                (行业：{{ item.keyvalue }}) </span>{{ item.push_system ?? '' }}
                        </div>
                    </a-select-option>
                </a-select>
            </a-form-item-rest>
            <a-form-item-rest>
                <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :value="state.organizational_form" @change="
                        (res) => {
                            selectChange(res, 'organizational_form')
                        }
                    " placeholder="请选择">
                    <a-select-option v-for="(item, index) in state.organizationalFormList" :key="index" :value="item">
                        {{ item }}
                    </a-select-option>
                </a-select>
            </a-form-item-rest>
        </div>
        <a-form-item label="上级行业" name="ondustry_representation_four"
            v-if="state.ondustry_representation_id && state.ondustry_representation_id >= 100000">
            <HangyeFour v-model:value="state.ondustry_representation_four" @change="triggerChange"></HangyeFour>
        </a-form-item>
        <div style="margin-top: 5px">
            主体名称预览：
            <span style="color: red; cursor: pointer" @click="
                (event) => {
                    handleNameClick(event)
                }
            ">{{ state.full_name }}</span><a @click="change_zihao_postion" class="ml-3x"
                v-if="props.principalType == 1 && state.name_division && state.name_word_mark && state.ondustry_representation && state.organizational_form">地域排序换位置</a>
            <span v-if="props.principalType == 2 || props.principalType == 3 || props.principalType == 4" class="ml-3x">
                <a-checkbox v-model:checked="state.no_postfix" @change="
                    (res) => {
                        checkboxChange('no_postfix')
                    }
                ">无后缀</a-checkbox>
            </span>
            <span v-if="props.principalType == 1 && props.isFiliale == 1" class="ml-3x">
                <a-checkbox v-model:checked="state.no_word" @change="
                    (res) => {
                        checkboxChange('no_word')
                    }
                ">无字号</a-checkbox>
            </span>
            <a class="ml-3x" @click="getHangye()">获取行业</a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { reactive, watch, onUnmounted, nextTick } from 'vue'
const emit = defineEmits(['update:value'])
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
import { message } from 'ant-design-vue'
import { trimAll } from '@/utils/util'
import { getOrganizationalForm } from '../../customerFn'
import HangyeFour from './HangyeFour.vue'
let timer: any = null
const props = defineProps({
    value: {
        type: Object
    },
    principalType: {
        type: Number
    },
    company_type_id: {
        type: Number
    },
    business_type: {
        type: Number
    },
    isFiliale: {
        type: Number
    },
    is_heming: {
        type: Number,
        default: 2
    },
    bensheng_flag: {
        type: String,
        default: '43'
    },
    push_system: {
        type: [Number, null],
        default: null
    }
})
interface IState {
    options: any[]
    name_division: string
    full_name: string
    name_division_position: number
    filiale_full_name: string
    name_word_mark: string
    ondustry_representation: string | undefined
    organizational_form: string | null
    ondustry_representation_type: number | null
    ondustry_representation_id: number | null
    ondustry_representation_four: string | undefined
    no_postfix: boolean
    no_word: boolean
    isFirst: boolean
    organizationalFormList: any[]
    ondustry_keyword: string
    hangyeInterval: any
}
const state = reactive<IState>({
    options: [],
    name_division: '',
    full_name: '',
    name_division_position: 0,
    filiale_full_name: '',
    name_word_mark: '',
    ondustry_representation: undefined,
    organizational_form: '',
    ondustry_representation_type: null,
    ondustry_representation_id: null,
    ondustry_representation_four: undefined,
    no_postfix: false,
    no_word: false,
    isFirst: true,
    organizationalFormList: [],// 组织形式
    ondustry_keyword: '',
    hangyeInterval: {
        timer: null,
        time: 5000
    }
})
onUnmounted(() => {
    clearInterval(state.hangyeInterval.timer)
})
watch(
    () => props.value,
    (val) => {
        if (val) {
            state.name_division = val.name_division || ''
            state.filiale_full_name = val.filiale_full_name || null
            state.name_word_mark = val.name_word_mark || ''
            state.ondustry_representation = val.ondustry_representation || ''
            state.ondustry_representation_type = val.ondustry_representation_type || null
            state.ondustry_representation_id = val.ondustry_representation_id || null
            if (state.ondustry_representation && val.ondustry_representation_id == 0) {
                state.ondustry_representation_id = 0 //如果选了行业，可能id真的为0，不是null
            }
            state.ondustry_representation_four = val.ondustry_representation_four || ''
            state.organizational_form = val.organizational_form || ''
            state.name_division_position = val.name_division_position || 0
            state.no_postfix = val.no_postfix == 1 ? true : false
            state.no_word = val.no_word == 1 ? true : false
            state.full_name = val.full_name || ''

            if (val.ondustry_representation) {
                if (!state.isFirst) return
                state.isFirst = false
                handleSearch(val.ondustry_representation)
            }
        }
    },
    { deep: true }
)
watch(
    () => props.principalType,
    (val) => {
        state.organizationalFormList = getOrganizationalForm(props.principalType, props.isFiliale, props.push_system)
        if (val == 1) {
            state.organizational_form = state.organizationalFormList[0]
        } else {
            state.organizational_form = null
        }
        state.ondustry_representation = ''
        state.ondustry_representation_type = null
        state.ondustry_representation_id = null
        state.ondustry_representation_four = ''
        state.options = []
        triggerChange()
    },
    { deep: true }
)
watch(
    () => props.push_system,
    (newval, oldval) => {
        if (oldval) {
            //切换平台，如果由湖南变成了西安，则需要重新选择行业
            state.ondustry_keyword = ''
            state.ondustry_representation = ''
            state.ondustry_representation_type = null
            state.ondustry_representation_id = null
            state.ondustry_representation_four = ''
            state.options = []
            nextTick(() => {
                triggerChange()
            })
        }
    },
    { deep: true }
)
watch(
    () => props.push_system,
    (newval, oldval) => {
        if (oldval) {
            state.organizational_form = null
        }
        if (oldval != newval) {
            //切换平台，如果由湖南变成了西安
            nextTick(() => {
                state.organizationalFormList = getOrganizationalForm(props.principalType, props.isFiliale, props.push_system)
            })
        }
    },
    { deep: true }
)
watch(
    () => props.isFiliale,
    (val) => {
        state.organizationalFormList = getOrganizationalForm(props.principalType, props.isFiliale, props.push_system)
        if (props.principalType == 1) {
            state.organizational_form = state.organizationalFormList[0]
        } else {
            state.organizational_form = null
        }
        nextTick(() => {
            triggerChange()// 在所有 watch 执行后才执行
        })

    },
    { deep: true }
)
watch(
    () => props.company_type_id,
    (newVal, oldVal) => {
        //有字号并且是合伙企业，不然会重复
        if (state.name_word_mark && props.principalType == 4) {
            triggerChange()
        }
    }
)
const change_zihao_postion = () => {
    state.name_division_position += 1
    if (state.name_division_position == 3) {
        state.name_division_position = 0
    }
    triggerChange()
}
const inputChange = (value, type) => {
    if (type == 'name_division') {
        value.target.value = value.target.value.replace('巿', '市')
    } else if (type == 'filiale_full_name') {
        value.target.value = value.target.value.replaceAll('(', '（').replaceAll(')', '）')
    }
    value.target.value = trimAll(value.target.value)
    state[type] = value.target.value
    triggerChange()
}
const selectChange = (value, type) => {
    if (props.isFiliale == 1) {
        state.name_division = ''
        state.ondustry_representation = ''
    } else {
        state.filiale_full_name = ''
    }
    state[type] = value
    triggerChange()
}
const checkboxChange = (type) => {
    triggerChange()
}
const triggerChange = () => {
    let full_name = ''
    if (props.isFiliale == 1) {
        if (state.no_word) {
            //分公司可以没有字号
            state.name_word_mark = ''
        }
        full_name = `${state.filiale_full_name}${state.name_word_mark}${state.organizational_form}`
    } else {
        //公司需要根据位置
        if (state.name_division_position == 0) {
            full_name = state.name_division + state.name_word_mark + state.ondustry_representation + state.organizational_form
        } else if (state.name_division_position == 1) {
            full_name = state.name_word_mark + '（' + state.name_division + '）' + state.ondustry_representation + state.organizational_form
        } else {
            full_name = state.name_word_mark + state.ondustry_representation + '（' + state.name_division + '）' + state.organizational_form
        }
        //补上括弧
        if (!state.no_postfix) {
            if (props.principalType == 2) {
                full_name = full_name + '（个体工商户）'
            } else if (props.principalType == 3) {
                full_name = full_name + (props.bensheng_flag == '61' ? '（个人独资企业）' : '（个人独资）')
            } else if (props.principalType == 4) {
                if (props.company_type_id == 14) {
                    full_name = full_name + '（有限合伙）'
                } else if (props.company_type_id == 15) {
                    full_name = full_name + '（有限合伙分支机构）'
                } else if (props.company_type_id == 16) {
                    full_name = full_name + '（普通合伙）'
                } else if (props.company_type_id == 17) {
                    full_name = full_name + '（普通合伙分支机构）'
                } else if (props.company_type_id == 18) {
                    full_name = full_name + '（特殊普通合伙）'
                } else if (props.company_type_id == 19) {
                    full_name = full_name + '（特殊普通合伙分支机构）'
                }
            }
        }
    }
    emit('update:value', {
        name_division: state.name_division,
        filiale_full_name: state.filiale_full_name,
        name_word_mark: state.name_word_mark,
        ondustry_representation: state.ondustry_representation,
        organizational_form: state.organizational_form,
        ondustry_representation_type: state.ondustry_representation_type,
        ondustry_representation_id: state.ondustry_representation_id,
        ondustry_representation_four: state.ondustry_representation_four,
        name_division_position: state.name_division_position,
        no_postfix: state.no_postfix ? 1 : 2,
        no_word: state.no_word ? 1 : 2,
        full_name: full_name
    })
}
const handleSearch = (val: string) => {
    if (props.business_type != 1 || props.is_heming == 1) {
        state.options = [
            {
                id: val,
                keyname: val,
                keyvalue: val
            }
        ]
        return
    }
    clearTimeout(timer)
    if (val == '') {
        state.options = []
        return
    }
    // 必须中文
    var reg = /^[\u4E00-\u9FA5]+$/
    if (!reg.test(val)) {
        return
    }
    if (val.includes('有限公司')) {
        val = val.replace('有限公司', '')
    } else if (val.includes('有限责任公司')) {
        val = val.replace('有限责任公司', '')
    }
    state.ondustry_keyword = val
    timer = setTimeout(() => {
        if (props.principalType == 1 || props.principalType == 3 || props.principalType == 4) {
            let requestParam = {
                url: '/admin/v1/getCompanyStep?keys=' + val + '&push_system=' + props.push_system,
                method: 'get'
            }
            baseService(requestParam)
                .then((res) => {
                    if (!res.data.some((res) => res.keyname === val)) {
                        //西安如果没有这个行业，可以手动添加
                        if (props.push_system == 2) {
                            const randomNum = state.ondustry_representation_id && state.ondustry_representation_id >= 100000 ? state.ondustry_representation_id + 1 : 100000;
                            res.data.unshift({
                                keyname: val,
                                id: randomNum,
                                keyvalue: '请点击选择行业'
                            })
                        }
                    }
                    state.options = res.data
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        } else {
            let requestParam = {
                url: '/admin/v1/getIndividualStep?keys=' + val + '&push_system=' + props.push_system,
                method: 'get'
            }
            baseService(requestParam)
                .then((res: any) => {
                    if (!res.data.some((res) => res.keyname === val)) {
                        //西安如果没有这个行业，可以手动添加
                        if (props.push_system == 2) {
                            const randomNum = state.ondustry_representation_id && state.ondustry_representation_id >= 100000 ? state.ondustry_representation_id + 1 : 100000;
                            res.data.unshift({
                                keyname: val,
                                id: randomNum,
                                keyvalue: '请点击选择行业'
                            })
                        }
                    }
                    if (res.data.length == 0) {
                        message.error(res.msg)
                    } else {
                        state.options = res.data
                    }
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        }
    }, 500)
}
// 复制名称
const handleNameClick = (event) => {
    var input = document.createElement('input')
    //将input的值设置为需要复制的内容
    input.value = event.target.innerHTML
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功，尝试双击有惊喜！')
    //移除input标签
    document.body.removeChild(input)
}
const handleChange = (val, obj) => {
    if (obj.value >= 100000) {
        //西安手动添加的行业
    } else {
        state.ondustry_representation_four = ''
    }
    state.ondustry_representation = obj.label
    state.ondustry_representation_type = obj.title
    state.ondustry_representation_id = obj.value
    triggerChange()
}
defineExpose({
    inputChange,
    state
})
//去工商局重新获取行业
const getHangye = () => {
    if (!state.ondustry_keyword) {
        message.error('请先输入行业表述')
        return
    }
    const hide = message.loading({
        content: '查询中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: '/admin/v1/getHangyeStep',
        method: 'post',
        data: { indus: state.ondustry_keyword, main_type: props.principalType }
    }
    baseServicePlus(requestParam, state.hangyeInterval)
        .then((res: any) => {
            message.success(res.msg)
            //重新搜索一下
            handleSearch(state.ondustry_keyword)
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
}
</script>

<style lang="less" scoped>
.d-flex {
    justify-content: space-between;
}

.top {
    color: #1890ff;
    display: none;
    cursor: pointer;
}

.d-flex:hover {
    .top {
        display: block;
    }
}
</style>
<style lang="less">
.principalName {
    width: 500px !important;
    margin-left: -70px !important;
}
</style>
